module.exports = __webpack_public_path__ + "img/the-transcendent-one-returns.ba6388dc.webp";